// extracted by mini-css-extract-plugin
module.exports = {"root":"IAv6C","icon":"_3tkse"};